import { useEffect, useState } from "react";

// Ikki sahifa uchun react-router (340 KB) o'rniga kichik router.
//
// Muhim: o'tish `history.pushState` orqali qilinadi, to'liq sahifa yuklash
// emas — GTM'dagi konversiya (generate_lead) aynan `/thankyou` ga
// historyChange bo'lganda otiladi; to'liq yuklashda u ishlamay qoladi.

const EVENT = "fintech:navigate";

export function navigate(path) {
  if (window.location.pathname === path) return;
  window.history.pushState(null, "", path);
  window.dispatchEvent(new Event(EVENT));
  window.scrollTo(0, 0);
}

export function usePath() {
  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    const sync = () => setPath(window.location.pathname);
    window.addEventListener("popstate", sync); // brauzerdagi "orqaga"
    window.addEventListener(EVENT, sync);
    return () => {
      window.removeEventListener("popstate", sync);
      window.removeEventListener(EVENT, sync);
    };
  }, []);
  return path;
}
